import React from 'react';
import PropTypes from 'prop-types';

import Video from '../../../components/BrightcoveVideo';

import { Wrapper, VideoWrapper } from './ProductInstruction.style';
import Placeholder from '../../../components/Placeholder';

const ProductInstruction = ({ copy, video }) => (
  <Wrapper>
    <VideoWrapper>{video ? <Video {...video} /> : <Placeholder w="100%" pb="56.6%" />}</VideoWrapper>
  </Wrapper>
);

ProductInstruction.defaultProps = {
  copy: {},
  video: undefined,
};

ProductInstruction.propTypes = {
  copy: PropTypes.shape(),
  video: PropTypes.shape(),
};

export default ProductInstruction;



// WEBPACK FOOTER //
// ./src/pages/ProductPage/ProductInstruction/ProductInstruction.js